const makeover = () => import('../views/artistry/makeover')

export default [
  {
    path : '/artistry/makeover',
    name :'artistry_makeover',
    component : makeover
  },
]